import { useQuery } from "@tanstack/react-query";
import { categoriesService } from "@/services/categories.service";
import { collectionsService } from "@/services/collections.service";

export const useCategories = (activeOnly = true) =>
  useQuery({
    queryKey: ["categories", { activeOnly }],
    queryFn: () => categoriesService.list(activeOnly),
  });

export const useCollections = () =>
  useQuery({ queryKey: ["collections"], queryFn: () => collectionsService.list() });